import { createFileRoute, notFound } from "@tanstack/react-router";
import { getProductCategory } from "~/config/products";

export const Route = createFileRoute("/products/$category")({
  loader: ({ params }) => {
    const category = getProductCategory(params.category);
    if (!category) throw notFound();
    return category;
  },
});
